import { z } from 'zod';

export const ComplianceStatusSchema = z.string();

export type ComplianceStatus = z.infer<typeof ComplianceStatusSchema>;

export enum KnownComplianceStatus {
  NO_DATA = 'No Data',
  COMPLIANT = 'Compliant',
  NON_COMPLIANT = 'Non-Compliant',
  AT_RISK = 'At Risk',
}

export function isKnownComplianceStatus(
  status: ComplianceStatus,
): status is KnownComplianceStatus {
  return (Object.values(KnownComplianceStatus) as string[]).includes(status);
}
